import { render } from "./IncomeForm.vue?vue&type=template&id=3623fcc5&bindings={}"
import script from "./IncomeForm.vue?vue&type=script&lang=ts"
export * from "./IncomeForm.vue?vue&type=script&lang=ts"
script.render = render

export default script